export default {
      id: "vide-event_pedestrian-collision-usage",
      viewBox: "0 0 38 33",
      url: __webpack_public_path__ + "img/icons.svg#vide-event_pedestrian-collision",
      toString: function () {
        return this.url;
      }
    }